import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteQuarter,
  getAllQuarters,
} from "../../../redux/features/appraisalSlice";

const DeleteQuarter = ({ id, data }) => {
  const { loading } = useSelector((state) => state.assetmanagement);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Quarter"}
      deleteNote={"Are you sure? you want to delete this quarter ?"}
      api={deleteQuarter(id)}
      upDateCall={getAllQuarters(data)}
      loading={loading}
    />
  );
};

export default DeleteQuarter;
